// https://github.com/wix-private/fed-infra/blob/master/ab-translate/src/abTranslate-runtime.js
export function abTranslate(experiments, translations) {
    if (!experiments || experiments.toString() !== '[object Object]') {
        return translations;
    }
    if (!translations) {
        return {};
    }
    // create a hash that contains the conversion between the old key and the new key
    const abExperiments = {};
    for (const expKey in experiments) {
        if (Object.prototype.hasOwnProperty.call(experiments, expKey)) {
            const experimentValue = experiments[expKey];
            const isAbTest = /specs\.abTranslate\.(.*?)\.(.*)$/.exec(expKey);
            if (isAbTest) {
                const translationDetails = isAbTest[2];
                const [translationKey, specName] = translationDetails.split('abSpec-');
                let translationKeys;
                if (specName) {
                    translationKeys = Array.from(new Set(Object.keys(translations)
                        .filter(key => key.includes(specName))
                        .map(key => key.split('|abTranslate')[0])));
                }
                else {
                    translationKeys = [translationKey];
                }
                translationKeys.forEach(key => {
                    abExperiments[key] = key;
                    if (experimentValue !== '0') {
                        const specSuffix = specName ? `|${specName}` : '';
                        abExperiments[key] = `${key}|abTranslate_${experimentValue}${specSuffix}`;
                    }
                });
            }
        }
    }
    // replace existing translation keys with abTest results
    for (const translationKey in abExperiments) {
        // eslint-disable-line guard-for-in
        const translationHasExperiment = Object.prototype.hasOwnProperty.call(abExperiments, translationKey);
        const doesAbTranslationKeyExist = translations[abExperiments[translationKey]];
        if (translationHasExperiment && doesAbTranslationKeyExist) {
            translations[translationKey] =
                translations[abExperiments[translationKey]];
        }
    }
    return translations;
}
//# sourceMappingURL=ab-translate.js.map